import { CustomEventTypesEnum } from '../constants/customEventTypesEnum'

export function dispatchWebinarStartedCustomEvent() {
  document.dispatchEvent(new CustomEvent(CustomEventTypesEnum.start_webinar))
}
